(() => {
  const nav = document.querySelector('[data-product-navigation]');
  if (!nav) return;

  const currentHandle = nav.dataset.currentProductHandle;
  const collectionHandle = nav.dataset.collectionHandle || 'all';
  if (!currentHandle || !collectionHandle) return;

  let storedNavigation;
  try {
    storedNavigation = JSON.parse(localStorage.getItem(`rlewisstudio:collection-navigation:${collectionHandle}`));
  } catch (_error) {
    return;
  }

  const products = storedNavigation?.products;
  if (!Array.isArray(products) || products.length < 2) return;

  const currentIndex = products.findIndex((product) => product.handle === currentHandle);
  if (currentIndex < 0) return;

  const previousProduct = products[currentIndex - 1];
  const nextProduct = products[currentIndex + 1];

  const updateLink = (selector, linkedProduct) => {
    const link = nav.querySelector(selector);
    if (!link) return;

    if (!linkedProduct) {
      link.hidden = true;
      return;
    }

    const title = link.querySelector('[data-product-navigation-title]');
    link.href = linkedProduct.url;
    link.hidden = false;
    if (title) title.textContent = linkedProduct.title;
  };

  updateLink('[data-product-navigation-previous]', previousProduct);
  updateLink('[data-product-navigation-next]', nextProduct);
  nav.classList.toggle('product-navigation--empty', !previousProduct && !nextProduct);
})();
